module.exports = __webpack_public_path__ + "img/Cover_FS_21.55b0667f.jpg";